module.exports = new __parcel__URL__("upload-icon.b634893d.png").toString();